
import React from "react";
import { Switch, Route, useLocation, useParams, Redirect } from "react-router-dom";

import Index from "./Index";
import Home from "./pages/Parts/Home";
import NotFound from "./pages/404";
import Affiliate from "./pages/Offers/Affiliate";
import Rewards from "./pages/Offers/Rewards";
import BonusAff from "./pages/Offers/Affiliate/Bonus";
import Rules from "./pages/Rules";
import Notifications from "./pages/Notifications";


import Login from "./pages/Auth/Login";
import Register from "./pages/Auth/Register";
import UserStat from "./components/User/Stat/Modal";
import GameStat from "./components/Game/Stat";
import UserSetting from "./components/User/Setting";
import GamesHome from "./games/";
import Wingo from "./games/Wingo/Wingo";
import SlotsHome from "./games/Slots/index";
import Slots from "./games/Slots/Game";
import SportsHome from "./games/Sports/";
import GroupPage from "./pages/GroupPage";

import Crash from "./games/Crash";
import Keno from "./games/Keno";
import Wheel from "./games/Wheel";
import Limbo from "./games/Limbo";
import Mine from "./games/Mine";
import Hilo from "./games/Hilo";
import Hashdice from "./games/HashDice";
import ClassicDice from "./games/ClassicDice";
import SingleKeno from "./games/SingleKeno";
import Plinko from "./games/Plinko";
import VideoPoker from "./games/VideoPoker";
import Blackjack from "./games/BlackJack";
import Goal from "./games/Goal";
import Roulette from "./games/Roulette";
import SnackAndLadders from "./games/SnakeAndLadders";
import ThreeCardMonte from "./games/ThreeCardMonte";
import MagicWheel from "./games/MagicWheel";
import Tower from "./games/Tower";
import Diamond from "./games/Diamond";
import HighLow from "./games/HighLow";
import Lottery from "./games/Lottery";
import VipClub from "./pages/Offers/VipClub";
import Promotions from "./pages/Offers/Promotions";
import Missions from "./pages/Offers/Missions";
import OffersPage from "./pages/Offers/OffersPage";
import AffiliateDashboard from "./components/AffiliateDashboard";
import ProvablyFair from "./pages/Parts/ProvableFair";
import GlobalSettings from "./pages/Parts/GlobalSettings";
import Chat from "./pages/Parts/Chat";
import Casino from "./pages/BCCasino/Casino";
import styled from "styled-components";
import Dashboard from "./pages/Offers/Affiliate/Pages/Dashboard";
import RateAndRules from "./pages/Offers/Affiliate/Pages/RateAndRules";
import RefferalCodesAndFriends from "./pages/Offers/Affiliate/Pages/RefferalCodesAndFriends";
import DownloadBanners from "./pages/Offers/Affiliate/Pages/DownloadBanners";
import { AiOutlineHome } from "react-icons/ai";
import { PiGiftLight } from "react-icons/pi";
import { IoWalletOutline } from "react-icons/io5";
import { BiSupport } from "react-icons/bi";
import { CgProfile } from "react-icons/cg";

import Payment from "./pages/Parts/Payment_wallet/Payment";
import PaymentSuccess from "./pages/Parts/Payment_wallet/PaymentSuccess";
import ProvidersPage from "./pages/ProvidersPage";
import ProviderGamesPage from "./pages/ProviderGamesPage";
import ProtectedRoute from "ProtectedRoute";
import ForgetPassword from "./pages/Auth/ForgetPassword";
import GamePlayer from "./pages/GamePlayer";
import Transactions from "./pages/Transactions";
import MyBets from "./pages/MyBets";
import DynamicCmsPage from "./pages/DynamicCmsPage";

const MainRoute = styled.div`
  @media (max-width: 576px) {
    margin-top: 50px;
  }
`;
const ReferralRoute = (props) => {
  const { referralCode } = useParams(); // Use the hook inside a valid functional component
  console.log("code", referralCode);
  return (
    <Index
      t={props.t}
      content={
        <Home
          t={props.t}
          content={
            <Register
              referral={referralCode}
              history={props.history}
              show={true}
            />
          }
        />
      }
    />
  );
};

function Router(props) {
  const handleTabClick = (e) => {
    const tabs = document.querySelectorAll(".snapbet-bottom-bar-main li a");
    tabs.forEach((tab) => tab.classList.remove("active"));
    e.currentTarget.classList.add("active");
  };

  let location = useLocation();
  let background = location.state && location.state.background;
  let loc = location.pathname;
  const { t } = props;
  return (
    <>
      <MainRoute>
        <Switch history={props.history} location={background || location}>


          <Route
            path="/register"
            children={
              <Index
                t={t}
                content={
                  <Home
                    t={t}
                    content={
                      <Register t={t} history={props.history} show={true} />
                    }
                  />
                }
              />
            }
          />
          <Route
            path="/forgot-password"
            children={
              <Index
                t={t}
                content={
                  <Home
                    t={t}
                    content={
                      <ForgetPassword t={t} history={props.history} show={true} />
                    }
                  />
                }
              />
            }
          />
          <Route path="/referal/:referralCode" component={ReferralRoute} />
          <Route
            path="/providers/:categoryId"
            children={<Index t={t} content={<ProvidersPage />} />}
          />
          <Route
            path="/login"
            children={
              <Index
                t={t}
                content={
                  <Home
                    t={t}

                  />
                }
              />
            }
          />
          <Route
            path="/affiliate/:tab?"
            children={
              <Index
                t={t}
                content={<Affiliate t={t} history={props.history} />}
              />
            }
          />
          <Route
            path="/vip-club"
            children={<Index t={t} content={<VipClub t={t} />} />}
          />
          <ProtectedRoute>
            <Switch>

            <Route
              exact
              path="/"
              children={<Index t={t} location={loc} content={<Home t={t} />} />}
            />

            <Route
              path="/wingo"
              children={
                <Index
                  t={t}
                  content={
                    <Wingo
                      t={t}
                      content={
                        <Login t={t} history={props.history} show={true} />
                      }
                    />
                  }
                />
              }
            />
            <Route
              exact
              path="/casino"
              children={<Index t={t} content={<Casino />} />}
            />

            <Route
              path="/settings/:tab?"
              children={
                <Index
                  t={t}
                  content={<UserSetting t={t} history={props.history} />}
                />
              }
            />

            <Route
              path="/provably-fair"
              children={<Index t={t} content={<ProvablyFair />} />}
            />
            <Route
              path="/global-settings"
              children={<Index t={t} content={<GlobalSettings />} />}
            />

            <Route
              path="/promotions"
              children={
                <Index
                  t={t}
                  content={<Promotions t={t} history={props.history} />}
                />
              }
            />
            <Route
              path="/missions"
              children={
                <Index
                  t={t}
                  content={<Missions t={t} history={props.history} />}
                />
              }
            />
            <Route
              path="/offers"
              children={
                <Index
                  t={t}
                  content={<OffersPage t={t} history={props.history} />}
                />
              }
            />
            <Route
              path="/notifications"
              children={
                <Index
                  t={t}
                  content={<Notifications t={t} history={props.history} />}
                />
              }
            />

            <Route
              path="/rewards"
              children={
                localStorage.getItem("logged") ? (
                  <Index
                    t={t}
                    content={<Rewards t={t} history={props.history} />}
                  />
                ) : (
                  <Redirect to="/" />
                )
              }
            />
            <Route
              path="/lottery"
              children={
                <Index
                  t={t}
                  content={<Lottery t={t} history={props.history} />}
                />
              }
            />
            {/* <Route
          path="/pick2"
          children={
            <Index t={t} content={<Pick2 t={t} history={props.history} />} />
          }
        /> */}
            <Route
              path="/aff"
              children={
                <Index
                  t={t}
                  content={
                    <BonusAff params={location} history={props.history} t={t} />
                  }
                />
              }
            />
            <Route
              path="/rules"
              children={
                <Index
                  t={t}
                  content={
                    <Rules params={location} history={props.history} t={t} />
                  }
                />
              }
            />

            {/* <Route
            path="/chat"
            children={
              <Index
                t={t}
                content={
                  <Chat params={location} history={props.history} t={t} />
                }
              />
            }
          /> */}
            <Route
              path="/user/:id"
              children={
                <Index
                  t={t}
                  content={
                    <Home
                      t={t}
                      content={
                        <UserStat
                          t={t}
                          history={props.history}
                          params={location}
                          byLink={true}
                        />
                      }
                    />
                  }
                />
              }
            />
            <Route
              path="/game/:id"
              children={
                <Index t={t} content={<GameStat t={t} params={location} />} />
              }
            />
            <Route
              path="/play/:id"
              children={
                <Index t={t} content={<GamePlayer t={t} />} />
              }
            />



            <Route
              path="/limbo"
              children={<Index t={t} content={<Limbo t={t} />} />}
            />
            <Route
              path="/hash-dice"
              children={<Index t={t} content={<Hashdice t={t} />} />}
            />
            <Route
              path="/classic-dice"
              children={
                <Index
                  t={t}
                  content={<ClassicDice t={t} history={props.history} />}
                />
              }
            />


            <Route
              path="/hilo"
              children={
                <Index t={t} content={<Hilo t={t} history={props.history} />} />
              }
            />


            <Route
              path="/blackjack"
              children={
                <Index t={t} content={<Blackjack history={props.history} />} />
              }
            />
            <Route
              path="/goal"
              children={
                <Index t={t} content={<Goal history={props.history} />} />
              }
            />





            <Route
              path="/tower"
              children={
                <Index t={t} content={<Tower history={props.history} />} />
              }
            />
            <Route
              path="/diamond"
              children={
                <Index t={t} content={<Diamond history={props.history} />} />
              }
            />
            <Route
              path="/high-or-low"
              children={
                <Index t={t} content={<HighLow history={props.history} />} />
              }
            />
            <Route
              path="/slots/:id"
              children={
                <Index t={t} content={<Slots t={t} history={props.history} />} />
              }
            />
            <Route
              path="/slots"
              children={<Index t={t} content={<SlotsHome t={t} />} />}
            />
            <Route
              path="/casino/originals"
              children={<Index t={t} content={<GamesHome t={t} />} />}
            />


            <Route
              path="/payment"
              children={<Index t={t} content={<Payment t={t} />} />}
            />
            <Route
              path="/transactions/:section?/:sub?"
              children={<Index t={t} content={<Transactions t={t} />} />}
            />
            <Route
              path="/my-bets/:section?/:sub?"
              children={<Index t={t} content={<MyBets t={t} />} />}
            />

            <Route
              path="/PaymentSuccess"
              children={<Index t={t} content={<PaymentSuccess t={t} />} />}
            />
            <Route path="/casino/providers" children={<Index t={t} content={<ProvidersPage />} />} />
            <Route path="/casino/provider/:providerId" children={<Index t={t} content={<ProviderGamesPage />} />} />
            <Route path="/casino/group/:slug" children={<Index t={t} content={<GroupPage />} />} />
            <Route path="/sports/group/:slug" children={<Index t={t} content={<GroupPage />} />} />
            <Route path="/casino/:slug" children={<Index t={t} content={<Casino />} />} />
            <Route path="/sports/:slug" children={<Index t={t} content={<SportsHome t={t} />} />} />
            <Route path="/group/:slug" children={<Index t={t} content={<GroupPage />} />} />
            <Route exact path="/sports" children={<Index t={t} content={<SportsHome t={t} />} />} />

            <Route
              path="/:pageKey"
              children={<Index t={t} content={<DynamicCmsPage />} />}
            />
            </Switch>
          </ProtectedRoute>
          <Route path="*">
            <NotFound history={props.history} />
          </Route>

        </Switch>
      </MainRoute>
    </>
  );
}

export default Router;
